import _, {identity} from 'lodash';
import React, {useCallback} from 'react';
import tinycolor2 from 'tinycolor2';
import {useI18n, useLocalI18n} from '../../../../data/hooks/i18nHooks';
import strings from '../../../sidepanel/EventWaitingRoom/ParticipantBubbles/BubblesFilter/BubblesFilter.i18n.csv';
import styles from './FilterSelection.module.scss';
import FilterSelectionValue from './FilterSelectionValue/FilterSelectionValue';
import {isCategoryParticipantsFilterTabActive} from '../EventParticipantsHeader/ParticipantsTabs/CategoryFilterParticipants/isCategoryParticipantsFilterTabActive';
import { useRecommendedParticipantsFilter } from '../../../../data/hooks/participant/useRecommendedParticipantsFilter';

const FilterSelection = props => {
    const {event, categories, filterParams = {}} = props,
        {categories: selectedCategories, connections} = filterParams,
        suggestedFilterParams = useRecommendedParticipantsFilter(event.id),
        i18n = useI18n(),
        i18nInnerCircle = useLocalI18n(strings);

    const handleClearFilter = useCallback(() => {
        app.store.dispatch(
            app.actions.participants.setFilterParams(event.id, {
                ...filterParams,
                categories: null,
                connections: null,
            })
        );
    }, [filterParams]);

    const handleInnerCircleClicked = useCallback(() => {
        app.store.dispatch(
            app.actions.participants.setFilterParams(event.id, {
                ...filterParams,
                connections: null,
            })
        );
    }, [event.id, filterParams]);

    const tags = _(selectedCategories)
        .map((options, cat) => {
            return _(options || [])
                .map(value => _(categories).chain().find({name: cat}).get('options').find({name: value}).value())
                .filter(identity)
                .map((option, i) => (
                    <FilterSelectionValue key={cat + '-' + option.name} color={option.color}>
                        {option.name}
                    </FilterSelectionValue>
                ))
                .value();
        })
        .flatten()
        .map(tag => [tag, ' '])
        .flatten()
        .value();

    if (connections) {
        tags.push(
            <button
                type="button"
                key="inner-circle"
                onClick={handleInnerCircleClicked}
                style={{
                    borderColor: tinycolor2(event.settings.primary_color).darken().toString(),
                    backgroundColor: event.settings.primary_color,
                }}>
                {i18nInnerCircle['inner-circle']}
            </button>
        );
    }

    if (!categories[0]) return null;
    if (!tags.length) return null;
    if (!isCategoryParticipantsFilterTabActive(filterParams, suggestedFilterParams)) return null;

    return (
        <div className={styles.FilterSelection}>
            {tags}
            <button type="button" className={styles.clearAll} onClick={handleClearFilter}></button>
        </div>
    );
};

export default FilterSelection;
